import React from "react";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { labourTierSelectOptions } from "../lib/labourConditionTiers";

function Field({ label, children }) {
  return (
    <div>
      <Label className="text-[10px] uppercase tracking-widest text-muted-foreground">{label}</Label>
      <div className="mt-1">{children}</div>
    </div>
  );
}

export default function LabourSurchargeTierFields({
  conditionRules,
  locationType,
  stackHeightTier = "BASE",
  carryDistanceTier = "BASE",
  onStackHeightTierChange,
  onCarryDistanceTierChange,
  disabled = false,
}) {
  if (!conditionRules) return null;
  const heightOpts = labourTierSelectOptions(conditionRules.height_tiers, {
    withinLabel: "Within stack width (1×)",
  });
  const distOpts = labourTierSelectOptions(conditionRules.distance_tiers, {
    withinLabel: "Within carry distance (1×)",
  });

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-1 border-t border-border/60">
      <Field label="Carry distance tier">
        <Select
          value={carryDistanceTier || "BASE"}
          onValueChange={onCarryDistanceTierChange}
          disabled={disabled}
        >
          <SelectTrigger className="h-9 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {distOpts.map((o) => (
              <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </Field>
      {locationType === "STACK" && (
        <Field label="Stack width tier">
          <Select
            value={stackHeightTier || "BASE"}
            onValueChange={onStackHeightTierChange}
            disabled={disabled}
          >
            <SelectTrigger className="h-9 text-xs">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {heightOpts.map((o) => (
                <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Field>
      )}
    </div>
  );
}
